/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, Suspense } from 'react';
import { Formik } from 'formik';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Box,
  Grid,
  CircularProgress,
  Card,
  CardMedia,
  CardContent,
  CardHeader,
  CardActions,
  TextField,
  Typography,
  Stack,
  MenuItem
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import SettingAction from '../../../store/actions/SettingAction';
import globalAction from '../../../store/actions/GlobalAction';
import Loader from '../../../utils/errorPages/Loader';

function SignatureSettingsView() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dataItem, setDataItem] = useState('');
  const [imageLoader, setImageLoader] = React.useState(true);
  const [images, setImages] = React.useState([]);
  const { signItemData, isLoading } = useSelector((state) => state.setting);
  const { statusData } = useSelector((state) => state.global);

  const { REACT_APP_API_URL } = process.env;

  const { code } = useParams();

  useEffect(() => {
    dispatch(globalAction.getClientStatus());
    dispatch(SettingAction.getSignatureItem(code));
  }, [dispatch, code]);

  useEffect(() => {
    if (signItemData && signItemData !== undefined) {
      setDataItem(signItemData);
    }
  }, [signItemData]);

  useEffect(() => {
    setImageLoader(true);
    if (dataItem && dataItem !== undefined && dataItem !== '') {
      if (dataItem.signature && dataItem.signature !== undefined) {
        const arrValue = [];
        const arrObject = {
          path: dataItem.signature
        };
        arrValue.push(arrObject);
        setImages(arrValue);
      }
    }
    const timeoutId = setTimeout(() => {
      setImageLoader(false);
    }, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [dataItem]);

  const initialValues = {
    name: dataItem?.name ?? '',
    status: dataItem?.status ?? '',
    signature: []
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      {isLoading ? <Loader /> : ''}
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/settings/signature">
            Signature Configuration
          </Typography>
          <Typography component="h2" variant="h2">
            / View
          </Typography>
        </Stack>
      </div>
      <Formik
        initialValues={initialValues}
        // validationSchema={ValidateBankDetails}
        enableReinitialize
        onSubmit={{}}
      >
        {({ errors, touched, values, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Grid container spacing={2}>
              <Grid item md={12} lg={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardHeader title="Signature Details" />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={2}>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="name"
                          disabled
                          name="name"
                          label="Name"
                          variant="outlined"
                          value={values.name}
                          margin="normal"
                          onChange={handleChange}
                          onBlur={(e) => {
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                            handleBlur(e);
                          }}
                          error={touched.name && Boolean(errors.name)}
                          helperText={touched.name && errors.name}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="addresses"
                          disabled
                          name="addresses"
                          label="Office Addresses"
                          variant="outlined"
                          value={(dataItem?.addresses ?? [])
                            .map((address) => address.address_type)
                            .join(', ')}
                          margin="normal"
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={1}>
                      <Grid item md={4} lg={4} xl={3}>
                        <div className="upload__image-wrapper">
                          {images && images.length > 0
                            ? images.map((image, index) => {
                                return (
                                  <Card
                                    sx={{
                                      height: '100%',
                                      width: '100%',
                                      border: '1px dashed rgba(20,20,20,0.75)',
                                      minHeight: '100px',
                                      maxHeight: '100px',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      cursor: 'pointer'
                                    }}
                                    key={index}
                                  >
                                    <Suspense fallback={<div>Loading...</div>}>
                                      {imageLoader ? (
                                        <CircularProgress size={20} />
                                      ) : (
                                        <CardMedia
                                          component="img"
                                          height="100"
                                          image={
                                            image.path
                                              ? `${REACT_APP_API_URL}/${image.path}`
                                              : image.data_url
                                          }
                                          alt="green iguana"
                                        />
                                      )}
                                    </Suspense>
                                  </Card>
                                );
                              })
                            : ''}
                        </div>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={2}>
                      <Grid item md={2} lg={2} xl={2}>
                        <TextField
                          id="status"
                          fullWidth
                          label="Status"
                          name="status"
                          margin="normal"
                          disabled
                          select
                          value={values.status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.status && touched.status}
                          helperText={errors.status && touched.status && errors.status}
                        >
                          {statusData &&
                            statusData.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.status}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={12} xl={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardActions sx={{ justifyContent: 'center', p: 3 }}>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="primary"
                      size="medium"
                      onClick={() => {
                        navigate('/settings/signature');
                      }}
                    >
                      Back
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
}
export default SignatureSettingsView;
